import { Controller } from "@hotwired/stimulus"

/**
 * @class Game.MOTController
 * @classdesc Stimulus controller for /game/ministry-of-truth.
 * @extends Controller
 */
export default class MOTController extends Controller {
  /**
   * Hides the next URL in window.history.secret.
   * Marks the page so any back/forward navigation off it redirects to
   * /game/history-rewritten/. Two layers:
   *   1. sessionStorage flag — checked on the next page (catches the
   *      common case where Chrome/Safari skip the pushState entry
   *      because the user hasn't interacted yet).
   *   2. pushState + popstate trap — fires once the user has clicked
   *      anywhere on the page.
   * Type `window.history` in the console and look for the secret property.
   */
  connect() {
    window.history.secret = "/game/back-to-base/"
    sessionStorage.setItem("onMinistryPage", "true")

    if (window.Turbo?.session) {
      window.Turbo.session.drive = false
    }

    history.pushState(null, "", window.location.href)
    this.handlePopState = () => {
      window.location.replace("/game/history-rewritten/")
    }
    window.addEventListener("popstate", this.handlePopState)
  }

  disconnect() {
    window.removeEventListener("popstate", this.handlePopState)
    if (window.Turbo?.session) {
      window.Turbo.session.drive = true
    }
  }
}
